import axios from "axios";
import { config } from "./constants";

export const axiosApiInstance = axios.create({
  baseURL: config.url.API_URL,
});

axiosApiInstance.interceptors.request.use((requestConfig) => {
  const authToken = localStorage.getItem("authToken");

  if (authToken && !requestConfig.headers.Authorization) {
    requestConfig.headers.Authorization = `Bearer ${authToken}`;
  }

  return requestConfig;
});

export const axiosStorageInstance = axios.create({
  baseURL: config.url.STORAGE_URL,
});

export const axiosPrinterInstance = axios.create({
  baseURL: config.url.PRINTER_URL,
});
